import { formatRelativeDate } from "./jobs-format";

function dateLocale(locale: string) {
  return locale.toLowerCase().startsWith("ar") ? "ar-AE" : "en-GB";
}

function validDate(value: string | null | undefined) {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatUaePassVerificationDate(
  value: string | null | undefined,
  locale: string,
) {
  const date = validDate(value);
  if (!date) return "";

  return new Intl.DateTimeFormat(dateLocale(locale), {
    day: "numeric",
    month: "short",
    year: "numeric",
  }).format(date);
}

export function formatTabbioJoinedDate(
  value: string | null | undefined,
  locale: string,
) {
  const date = validDate(value);
  if (!date) return "";

  return new Intl.DateTimeFormat(dateLocale(locale), {
    month: "long",
    year: "numeric",
  }).format(date);
}

export function formatCvLastUpdatedDate(
  value: string | null | undefined,
  locale: string,
  now = Date.now(),
) {
  return value ? formatRelativeDate(value, locale, now) : "";
}
